import React from 'react';
import MainLayoutContact from '../components/MainLayoutContact';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import { IoIosChatbubbles } from "react-icons/io";
import contact from '../assets/images/contact.jpg';


export default function Contact() {
  return (
    <>
    <MainLayoutContact>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>Contact Us</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Contact Us</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>


    <div className='inner_page_content contact_us_page'> 
      <div className='container'>

  


          <div className='row'>
            <div className='col-lg-6'>
            <h2>Contact Us </h2>
            <p>Got any questions about the product or scaling on our platform? We're here to help.</p>
      
      <div className='contact_address'> 
            <div className='row'>

            <div className='col-lg-12 mb-5'>
              <div className='d-flex'>

                  <div> <IoIosChatbubbles/> </div>
                  <div>
                      <h6>Chat to us</h6>
                      <p className='text-muted'>Our friendly team is here to help.</p>
                      <p>info@techtrenders.net</p>
                      <p>info@pierofcloudtech.com</p> 
                      </div> 

              </div> 
            </div>
{/* 
            <div className='col-lg-12 mb-3'>
              <div className='d-flex'>

                  <div> <IoIosChatbubbles/> </div>
                  <div>
                      <h6>Visit us</h6>
                      <p className='text-muted'>Come say hello at our office.</p>
                      <p>100 Smith Street Collingwood VIC 3066 AU</p> 
                      </div> 

              </div> 
            </div> */}

            <div className='col-lg-12 mb-5'>
              <div className='d-flex'>

                  <div> <IoIosChatbubbles/> </div>
                  <div>
                      <h6>Call us</h6>
                      <p className='text-muted'>Mon-Fri from 8am to 5pm.</p>
                      <p>+91 8520861115</p> 
                      <p>+1 6138848806</p> 
                      </div> 

              </div> 
            </div>

            <div className='col-lg-12'>
            <img className='img-fluid rounded' src={contact} alt='' />
            </div>

            </div>

            </div>
            </div>


            <div className='col-lg-6'>

            <div className='contact_form'>
              <h2>Got ideas? We've got the skills. Let's team up.</h2>
              <p>Tell us more about yourself and what you're got in mind.</p>

              <div className="mb-3">
            <label htmlFor="yourname" className="form-label">Your Name</label>
            <input type="text" className="form-control" id="yourname" placeholder="Your name" />
            </div>

            <div className="mb-3">
            <label htmlFor="youremail" className="form-label">Email address</label>
            <input type="email" className="form-control" id="youremail" placeholder="you@company.com" />
            </div>

            <div className="mb-3">
            <label htmlFor="yourmobile" className="form-label">Your mobile number</label>
            <input type="number" className="form-control" id="yourmobile" placeholder="Your mobile" />
            </div>


            <div className="mb-4">
            <label htmlFor="tellabout" className="form-label">Tell us a little about the project...</label>
            <textarea className="form-control" id="tellabout" rows="4"></textarea>
            </div>

            <div className="mb-4">
              <h6>How can we help?</h6>

                <div className='row'>
                  <div className='col-lg-6'>
                  <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="Websitedesign" value="Websitedesign" />
                            <label className="form-check-label" htmlFor="Websitedesign">Website design</label>
                            </div>
                  </div>

                  <div className='col-lg-6'>
                  <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="Contentcreation" value="Contentcreation" />
                            <label className="form-check-label" htmlFor="Contentcreation">Content creation</label>
                            </div>  
                    </div>

                    <div className='col-lg-6'>
                    <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="UXdesign" value="UXdesign" />
                            <label className="form-check-label" htmlFor="UXdesign">UX design</label>
                            </div>
                    </div>

                    <div className='col-lg-6'>
                    <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="Strategyconsulting" value="Strategyconsulting" />
                            <label className="form-check-label" htmlFor="Strategyconsulting">Strategy & consulting</label>
                            </div>
                    </div>

                    <div className='col-lg-6'>
                    <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="Userresearch" value="Userresearch" />
                            <label className="form-check-label" htmlFor="Userresearch">User research</label>
                            </div>
                    </div>

                    <div className='col-lg-6'>
                    <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="Other" value="Other" />
                            <label className="form-check-label" htmlFor="Userresearch">Other</label>
                            </div>
                    </div>
                    
                </div>

            </div>

            <div className="">
               <button className='btn btn-primary btn-lg'>Let's get started!</button>

            </div>


 
            </div>

            </div>

          </div>

      </div>
    </div>


    </MainLayoutContact>
    </>
  )
}
